/**
 * ep-cart.js — Daysleeper cart enhancements.
 * Patches the empty-state CTA to point to the mask product page.
 */
(function () {
  'use strict';

  var MASK_HANDLE = '3d-full-blackout-sleep-eye-mask-soft-breathable-for-night-and-travel';

  function patchEmptyState() {
    var btn = document.querySelector('.cart-items__empty-button');
    if (btn && !btn.dataset.dsPatched) {
      btn.href = '/products/' + MASK_HANDLE;
      btn.dataset.dsPatched = 'true';
    }
  }

  function init() {
    var drawerEl = document.querySelector('cart-drawer-component');
    if (!drawerEl) return;

    var observer = new MutationObserver(patchEmptyState);
    observer.observe(drawerEl, { childList: true, subtree: true });

    patchEmptyState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
